<template>
  <div>
    <a-descriptions
      title="项目信息"
      :column="3"
      class="simiot-descriptions simiot-descriptions-max-9"
    >
      <a-descriptions-item label="客户名称">
        {{ data.agent_name }}
      </a-descriptions-item>

      <a-descriptions-item label="项目状态">
        {{ data.status }}
      </a-descriptions-item>

      <a-descriptions-item label="项目编号">
        {{ data.item_no }}
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      v-if="data.product_type_slug == 'sim_card'"
      title="产品信息"
      :column="3"
      class="simiot-descriptions simiot-descriptions-max-9"
    >
      <a-descriptions-item label="产品">
        {{ data.order_type }} {{ data.product_type }}
      </a-descriptions-item>

      <a-descriptions-item label="产品名称">
        {{ data.product_name }}
      </a-descriptions-item>

      <a-descriptions-item label="产品价格(元)">
        {{ data.distributor_price | formatFloat }}<template v-if="showSimCardProductPriceAux">（{{ data.sim_card_product_price_aux | formatFloat }}）</template>
      </a-descriptions-item>

      <a-descriptions-item label="运营商种类">
        {{ data.carrier_type }}
      </a-descriptions-item>

      <a-descriptions-item label="卡品">
        {{ data.card_type }}
      </a-descriptions-item>

      <a-descriptions-item label="用户业务模式">
        {{ data.user_business_type }}
      </a-descriptions-item>

      <a-descriptions-item label="卡板价格">
        {{ data.card_type_price }}
      </a-descriptions-item>

      <a-descriptions-item label="产品周期">
        {{ data.service_cycle }}
      </a-descriptions-item>

      <a-descriptions-item label="采购卡数(张)">
        {{ data.product_count }}
      </a-descriptions-item>

      <a-descriptions-item label="产品容量">
        {{ data.package_capacity }}
      </a-descriptions-item>

      <a-descriptions-item label="服务周期数">
        {{ data.service_period }}
      </a-descriptions-item>

      <a-descriptions-item label="语音时长">
        {{ data.voice_capacity }}
      </a-descriptions-item>

      <a-descriptions-item label="产品备注">
        {{ data.remark }}
      </a-descriptions-item>

      <a-descriptions-item label="发卡备注">
        <template v-if="issueCardRemarkText">
          <a-tooltip
            v-if="issueCardRemarkNeedTooltip"
            :title="issueCardRemarkText"
            placement="topLeft"
            :overlay-style="{ maxWidth: '480px' }"
          >
            <span class="issue-card-remark issue-card-remark-truncate">{{ issueCardRemarkShort }}</span>
          </a-tooltip>
          <span
            v-else
            class="issue-card-remark"
          >{{ issueCardRemarkText }}</span>
        </template>
        <span v-else>—</span>
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      v-if="data.product_type_slug == 'sim_card'"
      title="配置参数"
      :column="3"
      class="simiot-descriptions simiot-descriptions-max-9"
    >
      <a-descriptions-item label="通信制式">
        {{ data.common_mode }}
      </a-descriptions-item>

      <a-descriptions-item label="流量类型">
        {{ data.flow_type }}
      </a-descriptions-item>

      <a-descriptions-item label="实名认证">
        {{ data.is_need_verified }}
      </a-descriptions-item>

      <a-descriptions-item label="沉默期(月)">
        {{ data.silent_period }}
      </a-descriptions-item>

      <a-descriptions-item label="测试流量">
        {{ data.test_traffic }} MB
      </a-descriptions-item> MB

      <a-descriptions-item label="测试期(月)">
        {{ data.test_period }}
      </a-descriptions-item>

      <a-descriptions-item label="空白卡自动激活套餐">
        {{ data.active_agent_product_name }}
      </a-descriptions-item>

      <a-descriptions-item label="空白卡激活周期">
        {{ data.active_agent_product_cycles }}
      </a-descriptions-item> 月

      <a-descriptions-item label="空白卡定套后沉默期">
        {{ data.convert_silent_period }} 月
      </a-descriptions-item> 月

      <a-descriptions-item label="空白卡定套后测试期">
        {{ data.convert_test_period }} 月
      </a-descriptions-item> 月

      <a-descriptions-item label="空白卡定套后限额">
        {{ data.convert_limit_usage_value }} 倍
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      v-if="data.product_type_slug == 'cpe'"
      title="产品信息"
      :column="3"
      class="simiot-descriptions simiot-descriptions-max-9"
    >
      <a-descriptions-item label="产品类型">
        {{ data.order_type }} {{ data.product_type }}
      </a-descriptions-item>

      <a-descriptions-item label="产品名称">
        {{ data.product_name }}
      </a-descriptions-item>

      <a-descriptions-item label="通信制式">
        {{ data.common_mode }}
      </a-descriptions-item>

      <a-descriptions-item label="采购数量(台)">
        {{ data.product_count }}
      </a-descriptions-item>

      <a-descriptions-item label="产品价格(元)">
        {{ data.distributor_price | formatFloat }}
      </a-descriptions-item>

      <a-descriptions-item label="产品备注">
        {{ data.remark }}
      </a-descriptions-item>

      <a-descriptions-item label="发货备注">
        <template v-if="issueCardRemarkText">
          <a-tooltip
            v-if="issueCardRemarkNeedTooltip"
            :title="issueCardRemarkText"
            placement="topLeft"
            :overlay-style="{ maxWidth: '480px' }"
          >
            <span class="issue-card-remark issue-card-remark-truncate">{{ issueCardRemarkShort }}</span>
          </a-tooltip>
          <span
            v-else
            class="issue-card-remark"
          >{{ issueCardRemarkText }}</span>
        </template>
        <span v-else>—</span>
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      v-if="data.product_type_slug == 'comm_module'"
      title="产品信息"
      :column="3"
      class="simiot-descriptions simiot-descriptions-max-9"
    >
      <a-descriptions-item label="产品类型">
        {{ data.order_type }} {{ data.product_type }}
      </a-descriptions-item>

      <a-descriptions-item label="产品名称">
        {{ data.comm_module_producer }} {{ data.comm_module_model }}
      </a-descriptions-item>

      <a-descriptions-item label="采购数量(片)">
        {{ data.product_count }}
      </a-descriptions-item>

      <a-descriptions-item label="产品价格(元)">
        {{ data.distributor_price | formatFloat }}
      </a-descriptions-item>

      <a-descriptions-item label="产品备注">
        {{ data.remark }}
      </a-descriptions-item>

      <a-descriptions-item label="发货备注">
        <template v-if="issueCardRemarkText">
          <a-tooltip
            v-if="issueCardRemarkNeedTooltip"
            :title="issueCardRemarkText"
            placement="topLeft"
            :overlay-style="{ maxWidth: '480px' }"
          >
            <span class="issue-card-remark issue-card-remark-truncate">{{ issueCardRemarkShort }}</span>
          </a-tooltip>
          <span
            v-else
            class="issue-card-remark"
          >{{ issueCardRemarkText }}</span>
        </template>
        <span v-else>—</span>
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      v-if="data.product_type_slug == 'other'"
      title="产品信息"
      :column="3"
      class="simiot-descriptions simiot-descriptions-max-9"
    >
      <a-descriptions-item label="产品">
        {{ data.order_type }} {{ data.product_type }}
      </a-descriptions-item>

      <a-descriptions-item label="名称">
        {{ data.product_name }}
      </a-descriptions-item>

      <a-descriptions-item label="采购数量">
        {{ data.product_count }}
      </a-descriptions-item>

      <a-descriptions-item label="产品价格(元)">
        {{ data.distributor_price | formatFloat }}
      </a-descriptions-item>

      <a-descriptions-item label="产品备注">
        {{ data.remark }}
      </a-descriptions-item>

      <a-descriptions-item label="发卡备注">
        <template v-if="issueCardRemarkText">
          <a-tooltip
            v-if="issueCardRemarkNeedTooltip"
            :title="issueCardRemarkText"
            placement="topLeft"
            :overlay-style="{ maxWidth: '480px' }"
          >
            <span class="issue-card-remark issue-card-remark-truncate">{{ issueCardRemarkShort }}</span>
          </a-tooltip>
          <span
            v-else
            class="issue-card-remark"
          >{{ issueCardRemarkText }}</span>
        </template>
        <span v-else>—</span>
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      title="项目金额"
      :column="3"
      class="simiot-descriptions simiot-descriptions-max-9"
    >
      <a-descriptions-item label="产品费用(元)">
        {{ data.product_fee | formatFloat }}
      </a-descriptions-item>

      <a-descriptions-item
        label="卡板费用(元)"
        v-if="data.product_type_slug == 'sim_card'"
      >
        {{ data.card_fee | formatFloat }}
      </a-descriptions-item>

      <a-descriptions-item label="小计(元)">
        {{ data.total_fee | formatFloat }}
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      title="配送信息"
      :column="3"
      class="simiot-descriptions simiot-descriptions-max-9"
    >
      <a-descriptions-item label="配送类型">
        {{ data.delivery_type }}
      </a-descriptions-item>

      <a-descriptions-item label="配送时效">
        {{ data.delivery_time_type }}
      </a-descriptions-item>

      <a-descriptions-item label="配送费用">
        {{ data.delivery_fee_type }}
      </a-descriptions-item>

      <a-descriptions-item label="配送地址">
        {{ data.delivery_address }}
        <a-tooltip>
          <template slot="title">
            点击复制
          </template>
          <a-icon
            class="simiot-cursor-pointer"
            type="copy"
            theme="twoTone"
            v-clipboard:copy="data.delivery_address"
            v-clipboard:success="onCopy"
            v-clipboard:error="onCopyError"
          />
        </a-tooltip>
      </a-descriptions-item>

      <a-descriptions-item label="配送备注">
        {{ data.delivery_remark }}
      </a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      title="发票信息"
      :column="3"
      class="simiot-descriptions simiot-descriptions-max-9"
    >
      <a-descriptions-item label="开票信息">
        {{ data.invoice_info }}
      </a-descriptions-item>

      <a-descriptions-item label="开票方">
        {{ data.invoice_from }}
      </a-descriptions-item>

      <a-descriptions-item label="开票类目">
        {{ data.invoice_category }}
      </a-descriptions-item>

      <a-descriptions-item label="税率">
        {{ data.invoice_rate }}
      </a-descriptions-item>

      <a-descriptions-item label="开票备注">
        {{ data.invoice_remark }}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
export default {
  name: 'AgentPurchaseItemBasicInfo',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    showSimCardProductPriceAux() {
      return this.data.product_type_slug === 'sim_card' &&
        this.data.sim_card_product_price_aux != null &&
        Number(this.data.sim_card_product_price_aux) > 0
    },
    issueCardRemarkText() {
      const t = this.data.issue_card_remark
      return t != null && String(t).trim() !== '' ? String(t).trim() : ''
    },
    issueCardRemarkNeedTooltip() {
      return this.issueCardRemarkText.length > 48
    },
    issueCardRemarkShort() {
      const t = this.issueCardRemarkText
      return t.length > 48 ? `${t.slice(0, 48)}…` : t
    }
  },
  methods: {
    onCopy: function(e) {
      this.$message.success('复制成功！')
    },

    onCopyError: function(e) {
      this.$message.error('复制失败！')
    }
  }
}
</script>

<style scoped>
.issue-card-remark {
  color: #f5222d;
}
.issue-card-remark-truncate {
  display: inline-block;
  max-width: 100%;
  cursor: default;
  vertical-align: bottom;
}
</style>
